module.exports = __webpack_public_path__ + "img/features-img3.f0c5bc6d.png";